module.exports = __webpack_public_path__ + "img/proList2_27_13.fe5b1f28.jpg";